import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icons/N.png';
const _withScopeId = n => (_pushScopeId("data-v-33c27c83"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left-sidebar",
  id: "left-sidebar"
};
const _hoisted_2 = {
  class: "left-menubar",
  id: "left-menubar"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "80px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "margin-top": "36px",
    "width": "53px",
    "height": "19px"
  },
  src: _imports_0
})], -1));
const _hoisted_4 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_5 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_6 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_7 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_8 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_9 = {
  key: 2,
  class: "munu_li"
};
const _hoisted_10 = {
  class: "right-area",
  id: "right-area"
};
const _hoisted_11 = {
  class: "fixed-header"
};
const _hoisted_12 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "padding-left": "20px"
  }
};
const _hoisted_13 = {
  class: "header-title"
};
const _hoisted_14 = {
  style: {
    "position": "absolute"
  }
};
const _hoisted_15 = {
  class: "head-button-group"
};
const _hoisted_16 = {
  style: {
    "min-width": "30px",
    "margin-left": "17px",
    "color": "#777777",
    "font-size": "13.5px",
    "font-weight": "400"
  }
};
const _hoisted_17 = {
  class: "scrollable-content"
};
const _hoisted_18 = {
  class: "visionBox"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "visionUl"
}, [/*#__PURE__*/_createElementVNode("li", null, "新增互动程序供应商。"), /*#__PURE__*/_createElementVNode("li", null, "自带可以不填物流编号。"), /*#__PURE__*/_createElementVNode("li", null, "新报修发送邮件至负责人。"), /*#__PURE__*/_createElementVNode("li", null, "报修邮件可跳转网站。"), /*#__PURE__*/_createElementVNode("li", null, "修复了一些已知问题。")], -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "visionUl"
}, [/*#__PURE__*/_createElementVNode("li", null, "下载的模板里加一列店铺类型筛选。"), /*#__PURE__*/_createElementVNode("li", null, "增加批量已送达功能。"), /*#__PURE__*/_createElementVNode("li", null, "分页全部改成25, 50, 200。"), /*#__PURE__*/_createElementVNode("li", null, "物流表加上上传记录。"), /*#__PURE__*/_createElementVNode("li", null, "安装页面已验收的店铺排序在最下面。"), /*#__PURE__*/_createElementVNode("li", null, "姓名按照中文名格式显示。"), /*#__PURE__*/_createElementVNode("li", null, "上传图片缩放处理。"), /*#__PURE__*/_createElementVNode("li", null, "安装进度新增导出按钮。"), /*#__PURE__*/_createElementVNode("li", null, "活动进度100%时自动发邮件给负责人。"), /*#__PURE__*/_createElementVNode("li", null, "活动进度品牌视角UI修改。")], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "visionUl"
}, [/*#__PURE__*/_createElementVNode("li", null, "品牌方隐藏step步骤，只有供应商显示。"), /*#__PURE__*/_createElementVNode("li", null, "Step步骤完成新增提示。"), /*#__PURE__*/_createElementVNode("li", null, "所有界面增加回退按钮。"), /*#__PURE__*/_createElementVNode("li", null, "活动总进度进安装进度，和活动无关的供应商不显示。"), /*#__PURE__*/_createElementVNode("li", null, "上传表格新增覆盖功能。"), /*#__PURE__*/_createElementVNode("li", null, "删除了子账号的权限管理功能。"), /*#__PURE__*/_createElementVNode("li", null, "修复了模板下载下来表格顺序错乱问题。"), /*#__PURE__*/_createElementVNode("li", null, "修复了模板下载下来表格时间格式不固定的问题。"), /*#__PURE__*/_createElementVNode("li", null, "供应商一键审核不通过时，可以重新拍照片并且不需要店员审核。"), /*#__PURE__*/_createElementVNode("li", null, "模板下载之后新增筛选功能。"), /*#__PURE__*/_createElementVNode("li", null, "导出数据点位按店铺排序。"), /*#__PURE__*/_createElementVNode("li", null, "修复了物流数据不对的问题。"), /*#__PURE__*/_createElementVNode("li", null, "物流表模板导出带数据生成，防止错误。"), /*#__PURE__*/_createElementVNode("li", null, "禁止上传非认领店铺的物流信息。"), /*#__PURE__*/_createElementVNode("li", null, "新增上传图片多选功能。"), /*#__PURE__*/_createElementVNode("li", null, "点位照片增加活动名称信息。"), /*#__PURE__*/_createElementVNode("li", null, "预约数量改为店铺数量。"), /*#__PURE__*/_createElementVNode("li", null, "同步时间改成按钮。"), /*#__PURE__*/_createElementVNode("li", null, "修复了密码输入特殊符号会出错的问题。"), /*#__PURE__*/_createElementVNode("li", null, "负责人部门增加层级。"), /*#__PURE__*/_createElementVNode("li", null, "注册账号昵称改成真实姓名。"), /*#__PURE__*/_createElementVNode("li", null, "浅灰颜色调整。"), /*#__PURE__*/_createElementVNode("li", null, "账号登录改为只可用邮箱登录。"), /*#__PURE__*/_createElementVNode("li", null, " 预约同步时间，同一家店，以一个时间为准（以最先上传的同店时间为准） "), /*#__PURE__*/_createElementVNode("li", null, "有验收单的时候可以不用店员签字，店员签字了可以不要验收单。")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "visionUl"
}, [/*#__PURE__*/_createElementVNode("li", null, "登录之后增加头像和个人昵称。"), /*#__PURE__*/_createElementVNode("li", null, "已结束的活动应该可以点进去查看，不能编辑。"), /*#__PURE__*/_createElementVNode("li", null, "供应商禁止删除品牌方上传的文件。"), /*#__PURE__*/_createElementVNode("li", null, "修复表格下载下来文件名是乱码的问题。"), /*#__PURE__*/_createElementVNode("li", null, "活动详情中展示备注信息。"), /*#__PURE__*/_createElementVNode("li", null, "修复活动文件管理管理员不能下载问题"), /*#__PURE__*/_createElementVNode("li", null, "上传活动封面增加裁剪功能。"), /*#__PURE__*/_createElementVNode("li", null, "修复子帐号权限问题。"), /*#__PURE__*/_createElementVNode("li", null, "活动界面店铺清单字体调整。"), /*#__PURE__*/_createElementVNode("li", null, "新增tab，基本信息，门头照片。"), /*#__PURE__*/_createElementVNode("li", null, "活动excel上传后立马刷新。"), /*#__PURE__*/_createElementVNode("li", null, "修复所有主账号无法给子账号审批问题。"), /*#__PURE__*/_createElementVNode("li", null, "删除了子账号的权限管理功能。"), /*#__PURE__*/_createElementVNode("li", null, "注册账号密码限制长度。"), /*#__PURE__*/_createElementVNode("li", null, "安装预约模板和店铺及点位空模板合并表格数据。"), /*#__PURE__*/_createElementVNode("li", null, "安装预约截止时间为活动开始前7天。"), /*#__PURE__*/_createElementVNode("li", null, "新增上传文件清单失败提示。"), /*#__PURE__*/_createElementVNode("li", null, "供应商只能生成自己供应商的施工码。"), /*#__PURE__*/_createElementVNode("li", null, "新增验收完毕页面。"), /*#__PURE__*/_createElementVNode("li", null, "文件名字下载下来重命名，前面名称，后面时间。"), /*#__PURE__*/_createElementVNode("li", null, "供应商只能签收自己供应商的专车快递。"), /*#__PURE__*/_createElementVNode("li", null, "完善发货进度搜索功能。"), /*#__PURE__*/_createElementVNode("li", null, "供应商的感叹号ICON，可以自己确定展示信息。"), /*#__PURE__*/_createElementVNode("li", null, "修复了供应商无法新增的问题。"), /*#__PURE__*/_createElementVNode("li", null, "供应商只可以看到自己相关活动的店铺。"), /*#__PURE__*/_createElementVNode("li", null, "供应商活动点位认领，负责人手机可能有多个。"), /*#__PURE__*/_createElementVNode("li", null, "活动详情中，供应商负责店铺清单服务数量以门店数量为准。"), /*#__PURE__*/_createElementVNode("li", null, " 店铺管理点位信息的照片取最近一次活动的实时最新的，可以一对多。 "), /*#__PURE__*/_createElementVNode("li", null, "店铺审核，供应商审核照片之后品牌才可以看到。"), /*#__PURE__*/_createElementVNode("li", null, "新增照片点位Gallery模式。"), /*#__PURE__*/_createElementVNode("li", null, "新增安装预约同步功能。"), /*#__PURE__*/_createElementVNode("li", null, "活动详情页新增物流上传功能。"), /*#__PURE__*/_createElementVNode("li", null, "修复了数据统计错误的问题。"), /*#__PURE__*/_createElementVNode("li", null, "修复了签名时手机自动转屏导致样式错乱的问题。"), /*#__PURE__*/_createElementVNode("li", null, "店铺管理新增导出功能，可以导出所有点位信息。"), /*#__PURE__*/_createElementVNode("li", null, "增加验收单拍照功能。")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_tooltip = _resolveComponent("a-tooltip");
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_avatar = _resolveComponent("a-avatar");
  const _component_a_badge = _resolveComponent("a-badge");
  const _component_a_dropdown = _resolveComponent("a-dropdown");
  const _component_router_view = _resolveComponent("router-view");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_menu, {
    openKeys: _ctx.state.openKeys,
    "onUpdate:openKeys": _cache[0] || (_cache[0] = $event => _ctx.state.openKeys = $event),
    selectedKeys: _ctx.state.selectedKeys,
    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _ctx.state.selectedKeys = $event),
    mode: "inline",
    theme: "light",
    "inline-collapsed": _ctx.state.collapsed,
    onClick: _ctx.menuSelect
  }, {
    default: _withCtx(() => [_ctx.permission.havePermission('活动管理', '活动详情') || _ctx.permission.havePermission('活动管理', '新建活动') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "1"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '1' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item1",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.activityTracking")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item1",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("home.activityTracking")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('互动数据', '查看互动数据') || _ctx.permission.havePermission('互动数据', '查看所有互动数据') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "2",
      class: "menuItemC"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '2' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item2",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.interactionData")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item2",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '2' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("home.interactionData")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('屏幕管理', '查看屏幕管理') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "3"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '3' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item3",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.screenManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item3",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '3' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("home.screenManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('报修', '报修查看') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "4"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '4' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item4",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.repairList")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item4",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '4' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("home.repairList")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('店铺管理', '查看店铺') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "5"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '5' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item5",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.storeManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item5",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '5' ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("home.storeManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.permission.havePermission('用户管理', '查询用户') ? (_openBlock(), _createBlock(_component_a_menu_item, {
      key: "6"
    }, {
      default: _withCtx(() => [_ctx.state.selectedKeys[0] == '6' ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        iconName: "menu_item6",
        iconSize: "18px",
        iconColor: "#e4e0e0"
      })) : (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.userManagement")), 1)]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          iconName: "menu_item6",
          iconSize: "22px",
          iconColor: "#797979"
        })]),
        _: 1
      })), _ctx.state.selectedKeys[0] == '6' ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("home.userManagement")), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["openKeys", "selectedKeys", "inline-collapsed", "onClick"]), _createElementVNode("div", {
    class: "visionIcon",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.dialogVisible = true)
  }, "version.1.03")])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_button, {
    id: "menu-button",
    style: {
      "width": "26px",
      "height": "26px",
      "border": "unset",
      "margin-right": "10px"
    },
    class: "button-circle",
    circle: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "Toggle",
      iconSize: "26px"
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.store.state.headerTitle), 1)])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
    onClick: _ctx.changeLanguage,
    class: "button-circle",
    style: {
      "margin-left": "30px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "enCn",
      iconSize: "20px"
    })]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_a_button, {
    class: "button-circle",
    style: {
      "margin-left": "14px",
      "margin-right": "15px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "bell",
      iconSize: "20px"
    })]),
    _: 1
  }), _createVNode(_component_a_dropdown, null, {
    overlay: _withCtx(() => [_createVNode(_component_a_menu, {
      onClick: _ctx.barCommand
    }, {
      default: _withCtx(() => [_createVNode(_component_a_menu_item, {
        key: "modify"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.editInfo")), 1)]),
        _: 1
      }), _createVNode(_component_a_menu_item, {
        key: "logout"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("home.logout")), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_a_badge, {
      dot: "",
      status: "success",
      offset: [-4, 16]
    }, {
      default: _withCtx(() => [_ctx.globalUser.avatar != null && _ctx.globalUser.avatar != '' ? (_openBlock(), _createBlock(_component_a_avatar, {
        key: 0,
        class: "touxiang",
        size: 40,
        src: _ctx.globalUser.avatar
      }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_a_avatar, {
        key: 1,
        class: "touxiang",
        size: 40,
        src: ''
      }))]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.globalUser.lastName) + " " + _toDisplayString(" ") + " " + _toDisplayString(_ctx.globalUser.firstName), 1)])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_router_view, {
    ref: "childComponent"
  }, null, 512), _ctx.buttonShow ? (_openBlock(), _createBlock(_component_vxe_button, {
    key: 0,
    onClick: _ctx.goBack,
    type: "text",
    class: "backNew"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "backNew",
      iconSize: "40px"
    })]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])]), _createVNode(_component_a_modal, {
    open: _ctx.dialogVisible,
    "onUpdate:open": _cache[4] || (_cache[4] = $event => _ctx.dialogVisible = $event),
    title: "更新说明",
    style: {
      "width": "800px"
    },
    onOk: _cache[5] || (_cache[5] = $event => _ctx.dialogVisible = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_tabs, {
      activeKey: _ctx.activeName,
      "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => _ctx.activeName = $event),
      class: "demo-tabs",
      onChange: _ctx.handleClick,
      "tab-position": "left"
    }, {
      default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
        tab: "v1.0.4",
        key: "1"
      }, {
        default: _withCtx(() => [_hoisted_19, _createVNode(_component_a_divider, {
          orientation: "right"
        }, {
          default: _withCtx(() => [_createTextVNode("2022.03.20")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_tab_pane, {
        tab: "v1.0.3",
        key: "2"
      }, {
        default: _withCtx(() => [_hoisted_20, _createVNode(_component_a_divider, {
          orientation: "right"
        }, {
          default: _withCtx(() => [_createTextVNode("2022.03.13")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_tab_pane, {
        tab: "v1.0.2",
        key: "3"
      }, {
        default: _withCtx(() => [_hoisted_21, _createVNode(_component_a_divider, {
          orientation: "right"
        }, {
          default: _withCtx(() => [_createTextVNode("2022.02.22")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_tab_pane, {
        tab: "v1.0.1",
        key: "4"
      }, {
        default: _withCtx(() => [_hoisted_22, _createVNode(_component_a_divider, {
          orientation: "right"
        }, {
          default: _withCtx(() => [_createTextVNode("2022.01.31")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["activeKey", "onChange"])])]),
    _: 1
  }, 8, ["open"])], 64);
}